<template>
  <span>
    <button :class="'btn ' + (montrerBarquettes ? 'btn-primary' : 'btn-secondary')" @click="toggleBarquettes">Barquettage</button>
    <div v-if="montrerBarquettes" id="barquettes" :style="dropLeft ? 'right:15px;' : ''">
      <table style="table-layout:fixed;width:300px;">
        <colgroup>
          <col span="1" width="42">
          <col span="1" width="52">
          <col span="1" width="202">
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Taille</th>
            <th>Désignation</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(barquette, iBarquette) in barquettesSelection" :key="iBarquette">
            <td>
              <input type="checkbox" v-model="barquette.Selectionne" >
            </td>
            <td>
              {{ barquette.Taille }}
            </td>
            <td>
              {{ barquette.Designation }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="flex-end" style="padding-top:5px;">
        <b-button :disabled="!modifBarquettes" class="btn-primary" @click="enregistrerBarquettes">Valider</b-button>
      </div>
    </div>
  </span>
</template>

<script>
import { connecteData } from "@/mixins/connecteData"
import { showAlerts } from '@/mixins/alerts'

export default {
  name: "boutonGestionBarquettes",
  components: {},
  mixins: [ connecteData, showAlerts ],
  props: {
    donnees: {type: String, default: ""},
    dropLeft: {type: Boolean, default: false},
    listeBarquette: {type: Array}, //Toutes les barquettes de l'établissement
    listeBarquetteSelectionnee: {type: Array} //Les barquettes sélectionnées pour la recette ou la structure de menu ou le lieu de portage ou les effectifs du lieu de portage
  },
  data() {
    return {
      barquettes: [], //Barquettes sélectionnées et enregistré dans les données supplémentaires
      barquettesActives: [], //Toutes les barquettes actives de l'établissement
      barquettesSelection: [], //Toutes les barquettes actives avec l'info sélectionné ou non (initialisé à partir du Json)
      barquettesAvant: "",
      montrerBarquettes: false,
    }
  },
  watch: {
    montrerBarquettes(visible) {
      setTimeout(() => {
        if (visible) {
          window.addEventListener("click", this.clickOutBarquettes)
        } else {
          window.removeEventListener("click", this.clickOutBarquettes)
        }
      }, 10)
    }
  },
  computed: {
    modifBarquettes() {
      return this.barquettesAvant !== JSON.stringify(this.barquettesSelection.map(b => {
          return {
            Taille: b.Taille,
            Designation: b.Designation,
            Id: b.Id,
            Selectionne: b.Selectionne
          }
        }))
    }
  },
  methods: {
    async toggleBarquettes() {
      //Clique sur le bouton "Barquettage"
      if (!this.montrerBarquettes) {//préparation des données
        //On affiche les barquettes
        //On a recu de la page appelante les barquettes configurées dans les données supplémentaires au format Json
        //On a recu également les barquettes de l'établissement pour afficher toutes les barquettes possibles, et cocher les barquettes contenu dans le Json recu



        this.barquettes = []
        this.barquettesSelection = []
        this.barquettesActives = []

        //plus besoin de traduire le JSON pour avoir les barquettes sélectionnées
        //this.barquettes = this.donnees && JSON.parse(this.donnees.replaceAll("'", "\""))
        //this.barquettes = this.barquettes && this.barquettes.Barquettage || []

        //On construit la liste des barquettes, avec l'info sélectionnée ou non
        this.barquettesActives = this.listeBarquette.filter(x => x.active)

        this.barquettesActives.forEach(x => {
          let bq = {
            Taille: x.taille,
            Designation: x.designation,
            Id: x.id,
            Selectionne: this.listeBarquetteSelectionnee.some(s => s.id === x.id) //On récupère les barquettes sélectionnées
          }
          this.barquettesSelection.push(bq)
        })

        this.barquettesAvant = JSON.stringify(this.barquettesSelection.map(b => {
          return {
            Taille: b.Taille,
            Designation: b.Designation,
            Id: b.Id,
            Selectionne: b.Selectionne
          }
        }))

        this.montrerBarquettes = true
      } else {
        if (this.modifBarquettes) {
          let result = await this.alerteConfirmation('Modifications non enregistrées', "Les modifications effectuées sur le barquettage n'ont pas été appliquées.<br/>Voulez-vous les enregistrer ?")
          if (result) {
            return this.enregistrerBarquettes()
          }
        }
        this.montrerBarquettes = false
      }
    },
    enregistrerBarquettes() {
      this.$emit("enregistrer", this.barquettesSelection.filter(s => s.Selectionne).map(b => {
        return {
          Taille: b.Taille,
          Designation: b.Designation,
          Id: b.Id
        }
      }))
      this.montrerBarquettes = false
    },
    clickOutBarquettes(e) {//fermeture du combo par clic en dehors
      if (this.montrerBarquettes && !e.target.closest("#barquettes") && !e.target.closest(".swal2-container")) {
        this.toggleBarquettes()
      }
    }
  },
  destroyed() {
    window.removeEventListener("click", this.clickOutBarquettes)
  }
}
</script>

<style>
#barquettes {
  position: absolute;
  z-index: 2;
  background: white;
  border: 1px solid black;
  border-radius: 3.5px;
  padding: 8px;
}
#barquettes td.erreur {
  border: 1px solid red;
}
</style>
